import { ItemList } from "../orm";

class BriefGalleryEventList extends ItemList {
  getEntityKey() {
    return "customer/brief_gallery_event";
  }
}

export const briefGalleryEventList = new BriefGalleryEventList("brief_gallery_event_default");
